import {Assessment as AssessmentType, useGetCoachInfo} from '@/api/Coach/useGetCoachInfo';
import {useProfiles} from '@/api/User/useProfiles';
import Spinner from '@/components/Loader/Spinner';
import {useCallback, useEffect, useMemo, useState} from 'react';
import {useParams} from 'react-router-dom';
// import {Button} from '@/components/Connects/Button';
import {useGlobalActiveAssessmentState} from '@/api/Coach/useGlobalActiveAssessmentId';
import {useGlobalActiveTeamState} from '@/api/Coach/useGlobalActiveTeamId';
import Dropdown, {DropdownOption} from '@/components/Dropdown/Dropdown';
import {CoachAssessment} from './CoachAssessment/CoachAssessment';
import {CoachAssessmentStats} from './CoachAssessmentStats/CoachAssessmentStats';

export const CoachHome = () => {
  const {teamId} = useParams();
  const {currentProfile} = useProfiles();
  const {data: coachInfo, isLoading} = useGetCoachInfo(currentProfile?._id);
  const team = coachInfo?.teams.find((team) => team._id === teamId);
  const [currentAssessment, setCurrentAssessment] = useState<AssessmentType | null>(null);
  const {globalActiveAssessmentId, setGlobalActiveAssessmentId} = useGlobalActiveAssessmentState();
  const {globalActiveTeamId, setGlobalActiveTeamId} = useGlobalActiveTeamState();
  const [defaultAssessmentOption, setDefaultAssessmentOption] = useState<DropdownOption | null>(null);

  const {allAssessments, assessmentOptions} = useMemo(() => {
    const allAssessments: any = {};
    const assessmentOptions: any = [];
    if (team) {
      for (const currentAssessment of coachInfo?.teamAssessments?.[team?._id] ?? []) {
        allAssessments[currentAssessment?._id] = currentAssessment;
        assessmentOptions.push({displayValue: currentAssessment?.name, value: currentAssessment?._id});
      }
    }
    return {allAssessments, assessmentOptions};
  }, [coachInfo?.teamAssessments, team]);

  useEffect(() => {
    if (globalActiveAssessmentId || assessmentOptions.length) {
      let assessmentId = globalActiveAssessmentId;
      if (teamId && globalActiveTeamId !== teamId) {
        assessmentId = assessmentOptions[0]?.value;
        setGlobalActiveAssessmentId(assessmentId);
        setGlobalActiveTeamId(teamId);
      }
      setCurrentAssessment(allAssessments[assessmentId]);
      setDefaultAssessmentOption({displayValue: allAssessments[assessmentId]?.name, value: assessmentId});
    }
  }, [
    allAssessments,
    assessmentOptions,
    globalActiveAssessmentId,
    teamId,
    globalActiveTeamId,
    setGlobalActiveTeamId,
    setGlobalActiveAssessmentId,
  ]);

  const handleAssessmentChange = useCallback(
    (option: DropdownOption) => {
      const assessmentId = option?.value;
      setCurrentAssessment(allAssessments[assessmentId]);
      setGlobalActiveAssessmentId(assessmentId);
    },
    [allAssessments, setGlobalActiveAssessmentId]
  );

  return (
    <div className="flex-1 flex flex-col w-full">
      {isLoading ? (
        <div className="w-full h-full flex items-center justify-center">
          <Spinner />
        </div>
      ) : !team ? (
        <div className="w-full h-full flex text-base mt-4 ml-4">Coach is not part of this team.</div>
      ) : currentAssessment ? (
        <>
          <div className="flex mt-4">
            <Dropdown
              placeholder="Select Assessment"
              defaultOption={defaultAssessmentOption}
              options={assessmentOptions}
              onSelect={handleAssessmentChange}
            />
          </div>
          <CoachAssessmentStats assessmentId={currentAssessment?._id ?? ''} />
          {/* <Button color="primary" variant="cta" text={'ASSIGN SESSIONS'} /> */}
          <CoachAssessment assessment={currentAssessment} />
        </>
      ) : (
        <div className="w-full h-full flex text-base mt-4 ml-4">No Assessment found</div>
      )}
    </div>
  );
};
